@use "~theme/typography";
@use "~theme/breakpoints";

$round-bottom: 0 0 4px 4px;

.doctorPanel {
  display: flex;
  margin: 20px auto;
  width: fit-content;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  background-color: var(--white);
}

.carousel {
  display: flex;
  flex-flow: row nowrap;
  max-width: 860px;
  background-color: var(--white);
  overflow-x: auto;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
}

.nav {
  width: 40px;
  display: flex;
  background-color: var(--blue-03);
  flex: 1;
  outline: none;
  border: none;
  justify-content: center;
  align-items: center;
  margin: 8px;
  cursor: pointer;

  &:focus-within {
    filter: drop-shadow(0 0 12px var(--hightlight-blue));
  }
}

.nav:active,
.nav:hover {
  outline: none;
}

.navDisabled {
  background-color: var(--gray-04);
  cursor: auto;
}

.doctors {
  cursor: pointer;
  display: flex;
  position: relative;
  width: fit-content;

  // Gray track in which the active doctor "indicator" sits.
  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: 4px;
    right: 4px;
    height: 4px;
    border-radius: $round-bottom;
    background-color: var(--gray-03);
  }
}

.button {
  background-color: var(--blue-01);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navDisabled .button {
  background-color: var(--gray-01);
}

.buttonLeft {
  margin-left: 4px;
}

.buttonRight {
  margin-right: 4px;
}

.noAvailableDoctors {
  @include typography.body;
  color: var(--blue-02);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  white-space: normal;
  cursor: default;

  p {
    max-width: 230px;
    margin: 0 32px;
    text-align: center;
    padding: 0;
  }
}
